import moment from "moment-timezone";

import CONSTANTS from "@/Constants";
import { scheduleBoardDateLabel } from "@/Scheduler/scheduleBoardDateLabel";

interface PeriodOptions {
  /** The board is showing a week rather than a single day. */
  weekView?: boolean;
  now?: Date;
}

// The control row's summary ends with the period it describes. The board date
// is navigable, so "today" is only true when the board shows today; any other
// day is named so "5 appts today" can never describe tomorrow. Week view says
// "this week" on the same terms, and names the range otherwise.
export function summaryPeriodLabel(
  date: Date,
  { weekView = false, now = new Date() }: PeriodOptions = {}
): string {
  if (weekView) {
    return moment(date).isSame(now, "isoWeek")
      ? "this week"
      : scheduleBoardDateLabel(date, true, { compact: true });
  }

  return moment(date).isSame(now, "day")
    ? "today"
    : moment(date).format(CONSTANTS.DATE_FORMAT_DAY_SHORT);
}
